export const GLOBAL_KEY = '__PRELOADED_STATE__';
export const MODAL_ID = 'modal-root';
